import { type MouseEvent } from "react";

import { Box, SxProps, Typography } from "@mui/material";

import { theme } from "@/src/theme/theme";

interface FooterLinkProps {
  text: string;
  href?: string;
  onClick?: (event: MouseEvent) => void;
  sx?: SxProps;
  newTab?: boolean;
}

const FooterLink = ({ text, href, newTab, onClick, sx }: FooterLinkProps) => {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      e.preventDefault();
      onClick(e);
    }
  };

  return (
    <Box
      component="div"
      sx={{
        display: "block",
        mb: 0.5,
        ...sx
      }}
    >
      <Typography
        component="a"
        variant="body1"
        href={href ?? "#"}
        target={href && newTab ? "_blank" : undefined}
        rel={href && newTab ? "noopener noreferrer" : "noreferrer"}
        onClick={handleClick}
        sx={{
          color: theme.palette.common.white,
          textDecoration: "none",
          cursor: "pointer",
          display: "inline-block",
          "&:hover, &:focus, &:visited": {
            color: theme.palette.common.white,
            textDecoration: "underline"
          }
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default FooterLink;
